import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@material-ui/core';
import styles from './AltMatWarningDailog.module.css';
import { InfoOutlined } from '@material-ui/icons';

const AltMatWarningDailog = ({ generateAgsn, handleClose, open, message }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className={styles.container} data-testid="confirmation-popup">
        <div className={styles.title}>
          <span>
            <InfoOutlined className={styles.info} />
          </span>

          <span className={styles.txt}>Info</span>
        </div>
        <div className={styles.note}>Note : Alternate part found </div>
        <Box bgcolor="#dadada3d" marginTop="10px" height="110px">
          <p className={styles.warningText}>{message}</p>
        </Box>
        <div className={styles.bottomRow}>
          <button className={styles.cancelBt} onClick={handleClose}>
            Cancel
          </button>
          <span>
            <button
              onClick={() => {
                handleClose();
                generateAgsn(true);
              }}
              className={styles.submitBt}
              data-testid="confirm-button"
            >
              Confirm
            </button>
          </span>
        </div>
      </div>
    </Modal>
  );
};

AltMatWarningDailog.propTypes = {
  generateAgsn: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AltMatWarningDailog;
